// extracted by mini-css-extract-plugin
module.exports = {"stickyEndpointHeader":"StickyEndpointHeader_stickyEndpointHeader__cIsC1","endpointPath":"StickyEndpointHeader_endpointPath__3hv3r","hidden":"StickyEndpointHeader_hidden__p4dk8"};